import { render, staticRenderFns } from "./Prepayments.vue?vue&type=template&id=e6f8cc42&scoped=true"
import script from "./Prepayments.vue?vue&type=script&lang=js"
export * from "./Prepayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f8cc42",
  null
  
)

export default component.exports